export default __webpack_public_path__ + "static/media/CMK-logo.cd26c162.png";